import React from "react";

const offerings = [
  {
    id: 1,
    icon: "/ai-bid-icon.svg",
    title: "AI Bid Generation",
    description:
      "Generate smart, project-specific proposals automatically using AI to save time and win more jobs.",
  },
  {
    id: 2,
    icon: "/automatic-bidding-icon.svg",
    title: "Automatic Bidding",
    description:
      "Let Bidzal submit bids on relevant projects automatically while you focus on your work.",
  },
  {
    id: 3,
    icon: "/sealed-bids-icon.svg",
    title: "Sealed Bids",
    description:
      "Submit private bids that stay confidential until reviewed, ensuring fair competition.",
  },
  {
    id: 4,
    icon: "/project-filters-icon.svg",
    title: "Project Filters",
    description:
      "Apply custom filters to bid only on projects that match your skills and budget preferences.",
  },
  {
    id: 5,
    icon: "/client-filters-icon.svg",
    title: "Client Filters",
    description:
      "Target quality clients by filtering based on ratings, payment history, and project fit.",
  },
  {
    id: 6,
    icon: "/scheduled-bidding-icon.svg",
    title: "Scheduled Bidding",
    description:
      "Schedule bids to be submitted at the best times for maximum visibility and engagement.",
  },
];


export default function Offerings() {
  return (
    <section className="py-16 bg-white mx-auto">
      <div className="mx-auto px-4 sm:px-6 lg:px-16 2xl:px-32">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl 2xl:text-5xl font-gilroy font-extrabold heading-strong text-primary-blue mb-4">
            Offerings
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
          Discover how Bidzal's smart automation, AI-powered proposals, and intelligent job matching transform the way you approach freelance bidding.

          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mx-auto xl:gap-x-8 2xl:gap-y-10 place-items-center md:place-items-stretch">
          {offerings.map((offering) => (
            <OfferingCard key={offering.id} offering={offering} />
          ))}
        </div>
      </div>
    </section>
  );
}

function OfferingCard({ offering }) {
  return (
    <div className="bg-light-blue rounded-2xl p-6 hover:shadow-lg transition-shadow duration-300 max-w-[350px]  xl:max-w-full 2xl:min-h-[260px] group hover:bg-primary-blue hover:text-white">
      {/* Icon Container */}
      <div className=" rounded-xl w-16 h-16 flex items-center justify-center mb-6 shadow-sm bg-white/0 group-hover:bg-white/10 transition-colors duration-200">
        <img
          src={offering.icon}
          alt={offering.title}
          className="w-full h-full object-contain"
        />
      </div>

      {/* Content */}
      <h3 className="text-xl md:text-2xl font-semibold text-gray-900 mb-3 group-hover:text-white">
        {offering.title}
      </h3>
      <p className="text-gray-600 text-sm md:text-base 2xl:text-lg leading-relaxed mb-16 group-hover:text-white/90">
        {offering.description}
      </p>
    </div>
  );
}
